import { render, staticRenderFns } from "./FormSpinbuttonWidth.vue?vue&type=template&id=6f670870"
import script from "./FormSpinbuttonWidth.vue?vue&type=script&lang=js"
export * from "./FormSpinbuttonWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports